import React from 'react';
import { Link } from 'react-router-dom';
import './Admin.css';

export default function AdminDashboard() {
  return (
    <div className="admin-dashboard">
      <h1>Dashboard</h1>
      <div className="admin-dashboard-cards">
        <Link to="/admin/categories" className="admin-dashboard-card">
          <h2>Categories</h2>
          <p>Manage documentation categories (label, uri, application, image).</p>
        </Link>
        <Link to="/admin/applications" className="admin-dashboard-card">
          <h2>Applications</h2>
          <p>Add or remove applications used in the category dropdown.</p>
        </Link>
        <Link to="/admin/articles" className="admin-dashboard-card">
          <h2>Articles</h2>
          <p>Create and edit articles, view version history.</p>
        </Link>
        <Link to="/admin/quick-links" className="admin-dashboard-card">
          <h2>Quick Links</h2>
          <p>Edit sidebar quick links and order.</p>
        </Link>
      </div>
    </div>
  );
}
